import React from "react";
import * as MUI from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { CRIMSON_RED } from "../../../../enums/Colors";
import ConfirmAndCancelButtons from "../../../../components/buttons/ConfirmAndCancelButtons";
import { useFormDeleteNoConfirm } from "../../../../hooks/useFormDelete";
import * as apiPaths from "../../../../enums/ApiPaths";
import { PRESCRIPTION_TEMPLATES_LIST } from "../../../../enums/QueryKeys";
import { useQueryClient } from "@tanstack/react-query";
import logger from "../../../../utils/logger";

export default function DeletePrescriptionTemplateDialog({ template, clinicId, onCancel, onDeleted }) {
  const { t } = useTranslation();
  const deletion = useFormDeleteNoConfirm(apiPaths.PRESCRIPTION_TEMPLATE, template?.id, null, 0);
  const queryClient = useQueryClient();

  async function onConfirm() {
    try {
      await deletion.submitForm();
      queryClient.invalidateQueries({ queryKey: [PRESCRIPTION_TEMPLATES_LIST + clinicId] });
      onCancel();
      onDeleted?.(template);
    } catch (err) {
      logger.error("Failed to delete prescription template", err);
    }
  }

  return (
    <MUI.Dialog
      open={Boolean(template)}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <MUI.Stack direction="row" justifyContent="flex-end" sx={{ p: 1 }}>
        <MUI.IconButton onClick={onCancel} size="small">
          <CloseIcon fontSize="small" />
        </MUI.IconButton>
      </MUI.Stack>
      <MUI.Stack pt={0} justifyContent="center" alignItems="center">
        <MUI.Avatar
          sx={{ bgcolor: MUI.alpha(CRIMSON_RED, 0.12), width: 64, height: 64 }}
        >
          <WarningAmberOutlinedIcon
            htmlColor={CRIMSON_RED}
            sx={{ fontSize: 34 }}
          />
        </MUI.Avatar>
      </MUI.Stack>
      <MUI.DialogTitle sx={{ textAlign: "center", fontWeight: 700 }}>
        {t("Delete")} {template?.title}
      </MUI.DialogTitle>
      <MUI.DialogContent sx={{ textAlign: "center" }}>
        <MUI.Typography color="text.secondary">
          {t("ReallyWantDeletePrescriptionTemplate")}
        </MUI.Typography>
      </MUI.DialogContent>
      <MUI.DialogActions sx={{ p: 2, pt: 0 }}>
        <ConfirmAndCancelButtons
          confirmTitle="Delete"
          cancelTitle=""
          onConfirm={onConfirm}
          isConfirmLoading={deletion.loading}
          confirmButtonProps={{ color: "error" }}
        />
      </MUI.DialogActions>
    </MUI.Dialog>
  );
}
